import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  font-size: 20px;
  margin: 20px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
`;
